<!-- <template>
  <div class="inner-container" :class="{ 'min-container': !getTabs }">
    <div class="page-header gestion-page-header d-flex align-items-center gap-2 flex-wrap">
    
        <div class="">
          <h1 class="mb-0 ">Gestion de dossiers</h1>
        </div> -->
      
     <template>
  <div class="inner-container" :class="{ 'min-container': !getTabs }">
    <div class="page-header">
      <h1>{{ $t("Gestion de dossiers") }}</h1>
   
   
        <b-button
             size="sm"
        variant="success"
        class="button-succes-style ml-2 float-right mb-2"
          @click="handleStore"
        >
          <font-awesome-icon icon="plus-circle" /> {{ $t("NEW") }}
        </b-button>
      <b-button
        size="sm"
        variant="info"
                class="button-succes-style ml-2 float-right mb-2"

        @click="$refs.importDossierModal.show()"
      >
        <font-awesome-icon icon="file-import" /> {{ $t("IMPORT") || "Importer" }}
      </b-button>
    </div>

    <storeModalVue @updateList="setup(true)"></storeModalVue>

    <div class="content">
      <div class="content-header">
        <searchBar
          :searchFunc="applyFilters"
          :showFiltre="true"
          :searchText="$t('SEARCH')"
          :filtre="currentFiltre"
          @returnValue="updateSearch($event)"
        ></searchBar>
        <b-modal id="entrepriseModal" ref="entrepriseModal">
          <template #modal-header="{ close }">
            <h5>{{  "Filtres" }}</h5>
            <b-button size="sm" @click="close()">
              <svg xmlns="http://www.w3.org/2000/svg" width="17.028" height="17.028" viewBox="0 0 17.028 17.028">
                <path d="M24.528,9.215,22.813,7.5l-6.8,6.8-6.8-6.8L7.5,9.215l6.8,6.8-6.8,6.8,1.715,1.715,6.8-6.8,6.8,6.8,1.715-1.715-6.8-6.8Z" transform="translate(-7.5 -7.5)" fill="#393939" />
              </svg>
            </b-button>
          </template>
          <form @submit.prevent="applyFiltersAndClose">
            <div class="center">
              <b-form-group v-if="isSuperAdmin" :label="$t('COMPANY_ID')">
                <searchInput
                  :list="getAllentreprises"
                  :loader="getentrepriseLoading"
                  label="lib"
                  :searchFunc="all_entreprises"
                  :selected="filterEntreprise"
                  @searchfilter="selectFilterEntreprise($event)"
                  :placeholder="$t('COMPANY_ID')"
                ></searchInput>
              </b-form-group>
              <b-form-group :label="$t('CUSTOMER')">
                <searchInput
                  :list="getAllclients"
                  :loader="getclientLoading"
                  label="nom"
                  :searchFunc="all_clients"
                  :selected="filterClient"
                  :filtre="filterClientFiltre"
                  @searchfilter="selectFilterClient($event)"
                  :placeholder="$t('CUSTOMER')"
                ></searchInput>
              </b-form-group>
              <b-form-group :label="$t('STATUT')">
                <b-form-select
                  v-model="filterStatus"
                  :options="filterStatusOptions"
                  value-field="value"
                  text-field="text"
                >
                  <template #first>
                    <b-form-select-option :value="null">{{ $t("ALL") || "Tous" }}</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
              <b-form-group :label="$t('DATE') + ' (' + ('Du') + ')'">
                <b-form-input v-model="filterDateFrom" type="date"></b-form-input>
              </b-form-group>
              <b-form-group :label="$t('DATE') + ' (' + ( 'Au') + ')'">
                <b-form-input v-model="filterDateTo" type="date"></b-form-input>
              </b-form-group>
            </div>
          </form>
          <template #modal-footer>
            <b-button variant="secondary" @click="clearFiltersAndClose">{{  "Réinitialiser" }}</b-button>
            <b-button variant="success" @click="applyFiltersAndClose">{{  "Appliquer" }}</b-button>
          </template>
        </b-modal>
      </div>
      <div class="filtre">
        <p class="table-count">{{ getTotalRowDossier }}   Gestion de dossiers </p>
        <div class="productTrie" v-if="filterEntreprise && filterEntreprise.lib">
          {{ filterEntreprise.lib }}
          <font-awesome-icon icon="times-circle" class="icons" @click="clearFilterEntreprise()" />
        </div>
        <div class="productTrie" v-if="filterClient && (filterClient.nom || filterClient.prenom)">
          {{ [filterClient.nom, filterClient.prenom].filter(Boolean).join(" ") }}
          <font-awesome-icon icon="times-circle" class="icons" @click="clearFilterClient()" />
        </div>
        <div class="productTrie" v-if="filterStatus">
          {{ getStatusLabel(filterStatus) }}
          <font-awesome-icon icon="times-circle" class="icons" @click="clearFilterStatus()" />
        </div>
        <div class="productTrie" v-if="filterDateFrom || filterDateTo">
          {{ filterDateFrom || "..." }} / {{ filterDateTo || "..." }}
          <font-awesome-icon icon="times-circle" class="icons" @click="clearFilterDate()" />
        </div>
        <div class="view-toggle-group ml-auto">
          <button
            type="button"
            class="view-toggle-btn"
            :class="{ active: viewMode === 'list' }"
            @click="viewMode = 'list'"
          >
            <font-awesome-icon icon="list" />
            {{ Liste }}
          </button>
          <button
            type="button"
            class="view-toggle-btn"
            :class="{ active: viewMode === 'grid' }"
            @click="viewMode = 'grid'"
          >
            <font-awesome-icon icon="th-large" />
            {{ Grille }}
          </button>
        </div>
      </div>
      <!-- Vue Liste -->
      <template v-if="viewMode === 'list'">
      <div v-if="selectedDossiers.length > 0" class="d-flex align-items-center gap-2 mt-2 mb-2">
       <b-button
  size="sm"
  variant="primary"
  class="button-export-style text-white"
  @click="handleExport"
>
  <font-awesome-icon icon="file-export" />
  {{  "Exporter" }}
</b-button>

     <b-button
  size="sm"
  variant="success"
  class="border-0 mx-2"
  @click="handleLockSelection"
  :disabled="lockActionLoading"
>
  <font-awesome-icon icon="lock" />
</b-button>

<b-button
  size="sm"
  variant="danger"
  class="border-0"
  @click="handleUnlockSelection"
  :disabled="lockActionLoading"
>
  <font-awesome-icon icon="unlock" />
</b-button>

      </div>
      <div class="table-rapport-style w-100">
        <table>
          <thead>
            <tr>
              <th style="border-radius: 0px 5px 0px 0px; width: 40px">
                <b-form-checkbox
                  :checked="isAllDossiersSelected"
                  :indeterminate="isSomeDossiersSelected"
                  @change="toggleSelectAllDossiers"
                  @click.native.stop
                />
              </th>
              <th>
               N° dossier
              </th>
              <th>
                {{ $t("NAME") }}
              </th>
              <th>
                {{ $t("CUSTOMER") }}
              </th>
              <th>
                {{ $t("DATE") }}
              </th>
              <th>
                {{ $t("STATUT") }}
              </th>
              <th>
               Sous statut 
              </th>
              <th class="action_head"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              role="row"
              class="ligneNormale"
              v-for="(data, i) in getAlldossiers"
              :key="data.id || i"
              @click="handleDossier(data)"
            >
              <td role="cell" @click.stop>
                <b-form-checkbox
                  :checked="isDossierSelected(data)"
                  @change="toggleDossierSelection(data)"
                />
              </td>
              <td role="cell">
                <font-awesome-icon
                  v-if="data.lock"
                  icon="lock"
                  class="icon-verrouillage mr-1"
                  :title="$t('VERROUILLE') || 'Verrouillé'"
                />
                <font-awesome-icon
                  v-else
                  icon="unlock"
                  class="icon-deverrouillage mr-1"
                  :title="$t('DEVERROUILLE') || 'Déverrouillé'"
                />
                {{ data.numero_dossier || "-" }}
              </td>
              <td aria-colindex="1" role="cell">
                {{ data.name }}
              </td>
              <td aria-colindex="2" role="cell">
                {{ data.client ? [data.client.nom, data.client.prenom].filter(Boolean).join(" ") || "-" : "-" }}
              </td>
              <td aria-colindex="3" role="cell">
                {{ moment(data.created_at).format("DD-MM-YYYY") }}
              </td>
              <td aria-colindex="4" role="cell">
                <span class="status-chip" :class="getStatusChipClass(data.status)">{{ getDossierPipelineStatus(data) }}</span>
              </td>
              <td aria-colindex="5" role="cell">
                {{ getDossierSousStatus(data) }}
              </td>
              <td aria-colindex="6" role="cell" class="action_col">
                <b-button
                  size="sm"
                  variant="info"
                  @click.prevent.stop="handleDossier(data)"
                  :title=" 'Voir le résumé'"
                >
                  <font-awesome-icon icon="file-alt" />
                </b-button>
                <b-button
                  size="sm"
                  variant="secondary"
                  @click.prevent.stop="goToDetail(data.id)"
                  :title="$t('SETTINGS') || 'Paramètres / Détail'"
                >
                  <font-awesome-icon icon="cog" />
                </b-button>
                <b-button
                  size="sm"
                  variant="danger"
                  @click.prevent.stop="handleDelete(data)"
                  v-if="!data.lock"
                >
                  <font-awesome-icon icon="trash" />
                </b-button>
                <b-button
                  size="sm"
                  variant="success"
                  @click.prevent.stop="handleUpdate(data)"
                  v-if="!data.lock"
                >
                  <font-awesome-icon icon="pencil-alt" />
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      </template>

      <!-- Vue Grille (Pipeline du processus actif) -->
      <div v-else-if="viewMode === 'grid'" class="gestion-grid-view">
        <div v-if="!activeProcessusId" class="">
      
   
         
        </div>
        <div v-else class="grid-pipeline-wrapper">
          <pipeline-embedded :processus-id="activeProcessusId" />
        </div>
      </div>

      <b-modal id="detailModal" ref="detailModal" size="xl" body-class="dossier-resume-modal">
        <template #modal-header="{ close }" v-if="dossierDetail">
          <h5>{{ dossierDetail.name }}</h5>
          <b-button size="sm" variant="link" @click="close()">
            <font-awesome-icon icon="times" />
          </b-button>
        </template>

        <b-spinner v-if="dossierResumeLoading" class="d-block mx-auto my-5" />
        <div v-else-if="dossierDetail" class="dossier-resume-content bg-white p-3">
          <div v-if="dossierResume" class="resume-grid">
            <!-- Dossier -->
            <div class="resume-card">
              <div class="resume-card-header">
                <font-awesome-icon icon="folder-open" class="mr-2" />
                {{ "Détail du dossier" }}
              </div>
              <div class="resume-card-body">
                <div class="resume-badge" :class="getStatusChipClass(dossierResume.dossier?.status)">
                  {{ getStatusLabel(dossierResume.dossier?.status) }}
                </div>
                <div class="resume-row"><span class="label">{{ $t("NAME") }}:</span> {{ dossierResume.dossier?.name || "-" }}</div>
                <div class="resume-row" v-if="dossierResume.dossier?.numero_dossier"><span class="label">{{ $t("NUMERO_DOSSIER") }}:</span> {{ dossierResume.dossier.numero_dossier }}</div>
                <div class="resume-row" v-if="dossierResume.dossier?.description"><span class="label">{{ $t("DESC") }}:</span> {{ dossierResume.dossier.description }}</div>
                <div class="resume-row" v-if="dossierResume.dossier?.created_at"><span class="label">{{ $t("DATE") }}:</span> {{ moment(dossierResume.dossier.created_at).format("DD/MM/YYYY") }}</div>
                <div class="resume-row" v-if="dossierResume.dossier?.lock != null"><span class="label">{{ $t("VERROUILLE") }}:</span> {{ dossierResume.dossier.lock ? $t("YES") : $t("NO") }}</div>
              </div>
            </div>

            <!-- Client -->
            <div class="resume-card" v-if="dossierResume.client">
              <div class="resume-card-header">
                <font-awesome-icon icon="user" class="mr-2" />
                {{ $t("CUSTOMER") }}
              </div>
              <div class="resume-card-body">
                <div class="resume-row"><span class="label">{{ $t("NAME") }}:</span> {{ [dossierResume.client.nom, dossierResume.client.prenom].filter(Boolean).join(" ") || "-" }}</div>
                <div class="resume-row" v-if="dossierResume.client.email"><span class="label">{{ $t("EMAIL") }}:</span> {{ dossierResume.client.email }}</div>
                <div class="resume-row" v-if="dossierResume.client.tel || dossierResume.client.phone?.formated_phone"><span class="label">{{ $t("PHONE") }}:</span> {{ dossierResume.client.phone?.formated_phone || dossierResume.client.tel || "-" }}</div>
                <div class="resume-row" v-if="dossierResume.client.rue || dossierResume.client.ville"><span class="label">{{ $t("ADDRESS") }}:</span> {{ [dossierResume.client.rue, dossierResume.client.cp, dossierResume.client.ville].filter(Boolean).join(" ") || "-" }}</div>
              </div>
            </div>

            <!-- Entreprise -->
            <div class="resume-card" v-if="dossierResume.entreprise">
              <div class="resume-card-header">
                <font-awesome-icon icon="building" class="mr-2" />
                {{ $t("COMPANY_ID") || "Entreprise" }}
              </div>
              <div class="resume-card-body">
                <div class="resume-row"><span class="label">Libellé:</span> {{ dossierResume.entreprise.lib || "-" }}</div>
                <div class="resume-row" v-if="dossierResume.entreprise.siret"><span class="label">SIRET:</span> {{ dossierResume.entreprise.siret }}</div>
                <div class="resume-row" v-if="dossierResume.entreprise.email"><span class="label">{{ $t("EMAIL") }}:</span> {{ dossierResume.entreprise.email }}</div>
              </div>
            </div>

            <!-- Pipelines & Sous-pipelines -->
            <div class="resume-card" v-if="dossierResume.pipelines?.length || dossierResume.sous_pipelines?.length">
              <div class="resume-card-header">
                <font-awesome-icon icon="stream" class="mr-2" />
                Pipeline
              </div>
              <div class="resume-card-body">
                <div v-if="dossierResume.pipelines?.length" class="mb-2">
                  <span class="label">{{ $t("STATUT") }}:</span>
                  <span v-for="p in dossierResume.pipelines" :key="p.id" class="badge mr-1" :style="{ backgroundColor: p.color || '#6c757d', color: '#fff' }">{{ p.name }}</span>
                </div>
                <div v-if="dossierResume.sous_pipelines?.length">
                  <span class="label">Sous statut:</span>
                  <span v-for="sp in dossierResume.sous_pipelines" :key="sp.id" class="badge badge-secondary mr-1">{{ sp.name }}</span>
                </div>
                <span v-if="!dossierResume.pipelines?.length && !dossierResume.sous_pipelines?.length">-</span>
              </div>
            </div>

            <!-- Statistiques (Photos, Commentaires, Montant CEE, Cumac, Documents) -->
            <div class="resume-card resume-stats resume-stats-docs">
              <div class="resume-card-header">
                <font-awesome-icon icon="chart-bar" class="mr-2" />
                Statistiques
              </div>
              <div class="resume-card-body resume-stats-inline">
                <div class="stat-item">
                  <span class="stat-value">{{ dossierResume.nombre_photos ?? 0 }}</span>
                  <span class="stat-label">Photos</span>
                </div>
                <div class="stat-item">
                  <span class="stat-value">{{ dossierResume.nombre_commentaires ?? 0 }}</span>
                  <span class="stat-label">Commentaires</span>
                </div>
                <div class="stat-item" v-if="dossierResume.montant_cee != null">
                  <span class="stat-value">{{ Number(dossierResume.montant_cee).toFixed(2) }} €</span>
                  <span class="stat-label">Montant CEE</span>
                </div>
                <div class="stat-item" v-if="dossierResume.cumac != null">
                  <span class="stat-value">{{ dossierResume.cumac }} kWh</span>
                  <span class="stat-label">Cumac</span>
                </div>
                <div class="stat-item">
                  <span class="stat-value">{{ resumeTotalDocuments }}</span>
                  <span class="stat-label">Documents</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Fallback: old layout when no dossierResume (API failed) -->
          <div v-else class="modal-test">
            <div class="part justify">
              <div class="divborder"><p>{{ $t("Informations dossiers") }}</p></div>
              <div class="left">
                <ul>
                  <h2 class="textstyle">{{ dossierDetail.name }}</h2>
                  <li><span class="title">{{ $t("CUSTOMER") }}:</span> <span class="textstyle">{{ dossierDetail.client ? [dossierDetail.client.nom, dossierDetail.client.prenom].filter(Boolean).join(" ") || "-" : "-" }}</span></li>
                  <li><span class="title">{{ $t("DELEGATAIRE") }}:</span> <span class="textstyle">{{ dossierDetail.delegataire ? dossierDetail.delegataire.name : "-" }}</span></li>
                  <li><span class="title">{{ $t("DESC") }}:</span> <span class="textstyle">{{ dossierDetail.description }}</span></li>
                </ul>
              </div>
            </div>
            <div class="part justify"><div class="divborder"><p>{{ $t("DOCUMENT") }}</p></div></div>
            <div class="document-filters mb-3" v-if="documentRows.length">
              <b-form-input
                v-model="documentSearch"
                size="sm"
                class="doc-filter-search"
                :placeholder="$t('SEARCH') || 'Rechercher...'"
                style="max-width: 220px; display: inline-block;"
              />
              <b-form-select
                v-model="documentFilterType"
                size="sm"
                class="doc-filter-select ml-2"
                :options="documentFilterTypeOptions"
                value-field="value"
                text-field="text"
                style="max-width: 140px; display: inline-block;"
              />
            </div>
            <div class="table-rapport-style w-100 doc-table-wrap">
              <table class="doc-table">
                <thead>
                  <tr>
                    <th style="width: 40px; border-radius: 5px 0 0 0">
                      <b-form-checkbox
                        :checked="filteredDocumentRows.length > 0 && filteredDocumentRows.every((item) => selectedDocumentIndices.includes(item.index))"
                        :indeterminate="filteredDocumentRows.some((item) => selectedDocumentIndices.includes(item.index)) && !filteredDocumentRows.every((item) => selectedDocumentIndices.includes(item.index))"
                        @change="toggleSelectAllFilteredDocuments"
                      />
                    </th>
                    <th>{{ $t("TYPE") || "Type" }}</th>
                    <th>{{ $t("NUMERO") || "N°" }}</th>
                    <th>{{ $t("DATE") || "Date" }}</th>
                    <th>{{ $t("DOWNLOAD") || "Téléchargement" }}</th>
                    <th>{{ $t("ACTION") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    role="row"
                    class="ligneNormale"
                    v-for="item in filteredDocumentRows"
                    :key="(item.doc.typeId || item.index) + '-' + item.index"
                  >
                    <td class="doc-check-cell" @click.stop>
                      <b-form-checkbox
                        :checked="selectedDocumentIndices.includes(item.index)"
                        @change="toggleDocumentSelection(item.index)"
                      />
                    </td>
                    <td>{{ item.doc.typeLabel }}</td>
                    <td>{{ item.doc.numero || "-" }}</td>
                    <td>{{ formatDocumentDate(item.doc.date) }}</td>
                    <td>
                      <div class="grey">
                        <b-spinner label="Spinning" v-if="fileLoading[item.index]"></b-spinner>
                        <font-awesome-icon
                          v-else-if="item.doc.file"
                          icon="download"
                          class="download-icon"
                          @click="downloadFile(item.doc.raw, item.index)"
                        />
                        <font-awesome-icon v-else icon="times" />
                      </div>
                    </td>
                    <td v-if="!dossierDetail.lock">
                      <b-spinner label="Spinning" v-if="fileLoading[item.index]"></b-spinner>
                      <b-button
                        size="sm"
                        variant="danger"
                        v-else-if="item.doc.file && !fileLoading[item.index]"
                        @click="handleDeleteFile(item.index)"
                      >
                        <font-awesome-icon icon="trash" />
                      </b-button>
                      <label
                        class="btn btn-primary btn-sm"
                        :for="`file_input` + item.index"
                        v-else-if="item.doc.typeLabel != 'Devis' && item.doc.typeLabel != 'Facture'"
                      >
                        <font-awesome-icon icon="plus" />
                      </label>
                      <label v-else class="btn btn-primary btn-sm" @click="openUpload(item.doc.raw)">
                        <font-awesome-icon icon="plus" />
                      </label>
                      <b-form-file
                        :id="`file_input` + item.index"
                        style="display: none"
                        @change="handleUpload($event, item.index)"
                      ></b-form-file>
                    </td>
                    <td v-else>
                      <b-button size="sm" variant="success" disabled>
                        <font-awesome-icon icon="plus" />
                      </b-button>
                    </td>
                  </tr>
                  <tr v-if="!documentRows.length">
                    <td colspan="7" class="text-center text-muted py-4">{{ $t("NO_DOCUMENT") || "Aucun document." }}</td>
                  </tr>
                  <tr v-else-if="documentRows.length && !filteredDocumentRows.length">
                    <td colspan="7" class="text-center text-muted py-4">{{ $t("NO_RESULT") || "Aucun résultat pour les filtres." }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <template #modal-footer>
          <div class="double">
            <b-button variant="danger" @click="resetModal()">
              <div class="block-spinner">
                {{ $t("CLOSE") }}
              </div>
            </b-button>

            <b-button
              variant="success"
              @click="handleSend"
              v-if="!dossierDetail.lock && dossierDetail.is_ready"
            >
              <div class="block-spinner">
                {{ $t("CONFIRM") }}
                <div v-if="getLoadingdossier" class="loading ml-2">
                  <div class="spinner-border" role="status"></div>
                </div>
              </div>
            </b-button>

            <b-button
              variant="success"
              @click="handleSend"
              v-if="!dossierDetail.lock && !dossierDetail.is_ready"
              disabled
            >
              <div class="block-spinner">
                {{ $t("CONFIRM") }}
              </div>
            </b-button>
          </div>
        </template>
      </b-modal>

      <b-modal
        id="ModelConfigDossier"
        ref="ModelConfigDossier"
        hide-footer
        @hide="v$.$reset()"
      >
        <template #modal-header>
          <h5>{{ $t("EDIT") }} {{ $t("Dossiers") }}</h5>
          <b-button size="sm" @click="resetModal()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17.028"
              height="17.028"
              viewBox="0 0 17.028 17.028"
            >
              <path
                id="Icon_material-close"
                data-name="Icon material-close"
                d="M24.528,9.215,22.813,7.5l-6.8,6.8-6.8-6.8L7.5,9.215l6.8,6.8-6.8,6.8,1.715,1.715,6.8-6.8,6.8,6.8,1.715-1.715-6.8-6.8Z"
                transform="translate(-7.5 -7.5)"
                fill="#393939"
              />
            </svg>
          </b-button>
        </template>
        <form v-if="dossierToConfig">
          <div class="center">
            <b-form-group :label="$t('NAME') + '*'" label-for="name">
              <b-form-input
                id="name"
                v-model="v$.dossierToConfig.name.$model"
                :state="validateState('name')"
                oninput="this.value = this.value.toUpperCase()"
                aria-describedby="name-feedback"
              ></b-form-input>
              <error-handle
                :list="v$.dossierToConfig.name.$errors"
                id="name-feedback"
              ></error-handle>
              <div v-if="erreurlist.name" class="error-message">
                <ul v-if="Array.isArray(erreurlist.name)">
                  <span v-for="(e, index) in erreurlist.name" :key="index">
                    {{ e }}
                  </span>
                </ul>
                <span v-else>{{ erreurlist.name }}</span>
              </div>
            </b-form-group>

            <b-form-group :label="$t('Description')">
              <b-form-textarea
                v-model="v$.dossierToConfig.description.$model"
                :state="validateState('description')"
                :placeholder="$t('Description')"
                maxlength="1000"
                rows="3"
              ></b-form-textarea>
              <error-handle
                :list="v$.dossierToConfig.description.$errors"
                id="description-feedback"
              ></error-handle>
              <div v-if="erreurlist.description" class="error-message">
                <ul v-if="Array.isArray(erreurlist.description)">
                  <span
                    v-for="(e, index) in erreurlist.description"
                    :key="index"
                  >
                    {{ e }}
                  </span>
                </ul>
                <span v-else>{{ erreurlist.description }}</span>
              </div>
            </b-form-group>
          </div>

          <div class="actionModel">
            <b-alert variant="warning" show v-if="errorU" class="messageError">
              {{ errorU }}
            </b-alert>
            <b-button variant="success" @click="EditDossier">
              <div class="block-spinner">
                {{ $t("EDIT") }}
                <div v-if="getLoadingdossier" class="loading ml-2">
                  <div class="spinner-border" role="status"></div>
                </div>
              </div>
            </b-button>
          </div>
        </form>
      </b-modal>

      <b-modal id="uploadDocument" ref="uploadDocument" hide-footer>
        <template #modal-header="{ close }">
          <h5 v-if="document.type && document.type.name == 'Devis'">
            {{ $t("Upload") }} {{ $t("ESTIMATE") }}
          </h5>
          <h5 v-else>{{ $t("Upload") }} {{ $t("INVOICE") }}</h5>
          <b-button size="sm" @click="close()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17.028"
              height="17.028"
              viewBox="0 0 17.028 17.028"
            >
              <path
                id="Icon_material-close"
                data-name="Icon material-close"
                d="M24.528,9.215,22.813,7.5l-6.8,6.8-6.8-6.8L7.5,9.215l6.8,6.8-6.8,6.8,1.715,1.715,6.8-6.8,6.8,6.8,1.715-1.715-6.8-6.8Z"
                transform="translate(-7.5 -7.5)"
                fill="#393939"
              />
            </svg>
          </b-button>
        </template>
        <form
          @submit.prevent="uploadDocument(tabIndex)"
          v-if="dossierDetail && document"
        >
          <b-tabs content-class="tabs" justified v-model="tabIndex">
            <b-tab :title="$t('Document existant')" active lazy>
              <div class="center">
                <b-form-group
                  :label="$t('ESTIMATE')"
                  v-if="document.type && document.type.name == 'Devis'"
                >
                  <searchInput
                    :list="computedDevis"
                    :loader="getdevisLoading"
                    label="numerodevis"
                    :searchFunc="devis"
                    @searchfilter="document.doc = $event"
                    :filtre="{
                      client: dossierDetail.client_id,
                    }"
                  ></searchInput>
                </b-form-group>

                <b-form-group :label="$t('INVOICE')" v-else>
                  <searchInput
                    :list="computedFacture"
                    :loader="getFactureLoading"
                    label="numerofacture"
                    :searchFunc="factures"
                    @searchfilter="document.doc = $event"
                    :filtre="{
                      client: dossierDetail.client_id,
                    }"
                  ></searchInput>
                </b-form-group>
              </div>
            </b-tab>

            <b-tab :title="$t('Depuis vos fichiers')" active lazy>
              <div class="center">
                <b-form-group
                  :label="$t('ESTIMATE')"
                  v-if="document.type && document.type.name == 'Devis'"
                >
                  <b-form-file
                    v-model="document.file"
                    :placeholder="$t('CHOOSE')"
                    plain
                    :required="tabIndex == 1"
                  ></b-form-file>
                </b-form-group>
                <b-form-group :label="$t('INVOICE')" v-else>
                  <b-form-file
                    v-model="document.file"
                    :placeholder="$t('CHOOSE')"
                    plain
                    :required="tabIndex == 1"
                  ></b-form-file>
                </b-form-group>
              </div>
            </b-tab>
          </b-tabs>
          <div class="actionModel">
            <b-button variant="success" type="submit">
              <div class="block-spinner">
                {{ $t("SAVE") }}
              </div>
            </b-button>
          </div>
        </form>
      </b-modal>

      <b-modal size="lg" centered id="ModelError" ref="ModelError">
        <template #modal-header="{ close }">
          <h5>{{ $t("ERROR") }}</h5>
          <b-button size="sm" @click="close()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17.028"
              height="17.028"
              viewBox="0 0 17.028 17.028"
            >
              <path
                id="Icon_material-close"
                data-name="Icon material-close"
                d="M24.528,9.215,22.813,7.5l-6.8,6.8-6.8-6.8L7.5,9.215l6.8,6.8-6.8,6.8,1.715,1.715,6.8-6.8,6.8,6.8,1.715-1.715-6.8-6.8Z"
                transform="translate(-7.5 -7.5)"
                fill="#fff"
              />
            </svg>
          </b-button>
        </template>
        <div class="messageError" v-if="erreur">{{ erreur }}</div>
        <template #modal-footer>
          <div class="actionModel">
            <b-button variant="danger" @click="hideModal('ModelError')">
              <div class="block-spinner">
                {{ $t("CLOSE") }}
              </div>
            </b-button>
          </div>
        </template>
      </b-modal>

      <deleteModalVue
        :loader="getLoadingdossier"
        :elemToDelete="dossierToDelete"
        :elemDelete="delete_dossier"
        @updateList="setup(false)"
      ></deleteModalVue>

      <b-modal id="importDossierModal" ref="importDossierModal" @hide="resetImportModal">
        <template #modal-header="{ close }">
          <h5>{{ $t("IMPORT") || "Importer" }} {{ $t("Dossiers") || "dossiers" }}</h5>
          <b-button size="sm" variant="link" @click="close()">
            <font-awesome-icon icon="times" />
          </b-button>
        </template>
        <div class="mb-3">
          <b-button
            variant="outline-primary"
            size="sm"
            :disabled="exportTemplateLoading"
            @click="handleExportTemplate"
          >
            <b-spinner v-if="exportTemplateLoading" small class="mr-1"></b-spinner>
            <font-awesome-icon v-else icon="download" class="mr-1" />
           Exporter le modèle
          </b-button>
        </div>
       <!-- <div class="mb-3 border-top pt-3">
          <p class="text-muted small mb-2">{{ $t("IMPORT_TEMPLATE_HELP") || "Importer un fichier modèle (template_dossiers_xxx.zip)" }}</p>
          <b-form-group :label="$t('TEMPLATE_FILE') || 'Fichier modèle'">
            <b-form-file
              v-model="importTemplateFile"
              accept=".zip"
              :placeholder="$t('CHOOSE_FILE') || 'Choisir un fichier...'"
              drop-placeholder="Glissez le fichier ici"
              :browse-text="$t('BROWSE') || 'Parcourir'"
            />
          </b-form-group>
          <b-button
            variant="outline-success"
            size="sm"
            :disabled="!importTemplateFile || importTemplateLoading"
            @click="handleImportTemplate"
          >
            <b-spinner v-if="importTemplateLoading" small class="mr-1"></b-spinner>
            {{ $t("IMPORT_TEMPLATE") || "Importer le modèle" }}
          </b-button>
        </div>  -->
        <div class="mb-3">
          <b-form-group :label="'Fichier'">
            <b-form-file
              v-model="importZipFile"
              accept=".zip"
              :placeholder=" 'Choisir un fichier...'"
              drop-placeholder="Glissez le fichier ici"
              :browse-text=" 'Parcourir'"
            />
          </b-form-group>
        </div>
        <template #modal-footer>
          <b-button variant="secondary" @click="$refs.importDossierModal.hide()">
            {{ $t("CANCEL") || "Annuler" }}
          </b-button>
          <b-button variant="success" @click="handleImport" :disabled="!importZipFile || importDossierLoading">
            <b-spinner v-if="importDossierLoading" small class="mr-1"></b-spinner>
            {{ $t("IMPORT") || "Importer" }}
          </b-button>
        </template>
      </b-modal>

      <b-pagination
        v-if="viewMode === 'list' && search == ''"
        v-model="page"
        :total-rows="getTotalRowDossier"
        :per-page="perPage"
        aria-controls="my-table"
        pills
        last-number
        first-number
        align="center"
        size="sm"
        @change="pagination"
        class=""
      ></b-pagination>
      <b-pagination
        v-else-if="viewMode === 'list'"
        v-model="page"
        :total-rows="getTotalRowDossier"
        :per-page="perPage"
        aria-controls="my-table"
        pills
        last-number
        first-number
        align="center"
        size="sm"
        @change="pagination"
        class=""
      ></b-pagination>
    </div>

    <div class="text-center center-spin">
      <b-spinner
        v-if="getLoadingdossier"
        variant="primary"
        label="Spinning"
        class="big-spin"
      ></b-spinner>
    </div>
    <CommentMarche to="/how-it-work/dossiers"></CommentMarche>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import { required, maxLength } from "@vuelidate/validators";
import deleteModalVue from "../components/ui/deleteModal.vue";
import storeModalVue from "../components/Ajoutmodel/dossiermodale.vue";
import errorHandle from "../components/ui/errorHandle.vue";
import CommentMarche from "../components/commentMarche.vue";
import moment from "moment";

export default {
  setup() {
    return { v$: useVuelidate({ $lazy: true, $autoDirty: true }) };
  },
  components: {
    deleteModalVue,
    storeModalVue,
    errorHandle,
    CommentMarche,
    PipelineEmbedded: () => import("./pipeline.vue"),
    searchInput: () => import("@/components/ui/searchInput"),
    searchBar: () => import("../components/ui/searchBar.vue"),
  },
  data() {
    return {
      viewMode: "list",
      search: "",
      dossierToConfig: null,
      dossierToDelete: null,
      dossierDetail: null,
      dossierResume: null,
      dossierResumeLoading: false,
      downloadLoader: false,
      importZipFile: null,
      importDossierLoading: false,
      importTemplateFile: null,
      importTemplateLoading: false,
      exportTemplateLoading: false,
      page: 1,
      perPage: 10,
      errorU: false,
      fileLoading: [],
      current_client: {
        id: null,
      },
      erreurlist: {
        name: null,
        client_id: null,
      },
      filtre_client: {
        id: null,
      },
      filterClient: null,
      filterEntreprise: null,
      filterStatus: null,
      filterDateFrom: "",
      filterDateTo: "",
      document: {
        type: null,
        file: null,
        doc: null,
      },
      tabIndex: 0,
      erreur: null,
      selectedDossiers: [],
      selectedDocumentIndices: [],
      documentSearch: "",
      documentFilterType: null,
      statusFallbacks: {
        DOSSIER_STATUS_EN_COURS: "Dossier en cours",
        DOSSIER_STATUS_NON_SIGNE: "Dossier non signé",
        DOSSIER_STATUS_SIGNE: "Dossier signé",
        DOSSIER_STATUS_POSE_EN_COURS: "Pose en cours",
        DOSSIER_STATUS_POSE_TERMINE: "Pose terminé",
        DOSSIER_STATUS_CONTROLE_A_PLANIFIER: "Contrôle à planifier",
        DOSSIER_STATUS_TRAITEMENT_ADMIN: "En traitement administratif",
        DOSSIER_STATUS_A_DEPOSER: "Dossier à déposer",
        DOSSIER_STATUS_DEPOSE: "Dossier déposé",
        DOSSIER_STATUS_PAYE: "Dossier payé",
      },
    };
  },
  validations() {
    return {
      dossierToConfig: {
        name: { required, maxLength: maxLength(100) },
        description: { maxLength: maxLength(1000) },
      },
    };
  },
  methods: {
    ...mapActions([
      "alldossier",
      "edit_dossier",
      "delete_dossier",
      "getDossierResume",
      "OcrFileTypes",
      "all_clients",
      "all_entreprises",
      "upload_file",
      "delete_file",
      "allfiles",
      "devis",
      "factures",
      "download_file",
      "send_dossier",
      "one_dossier",
      "export_dossier",
      "export_dossier_template",
      "import_dossier",
      "lock_dossier",
      "unlock_dossier",
      "lock_dossiers",
      "unlock_dossiers",
    ]),

    moment: function (date) {
      return moment(new Date(date));
    },
    formatDocumentDate(isoDate) {
      if (!isoDate) return "-";
      return this.moment(isoDate).format("DD/MM/YYYY");
    },
    toggleDocumentSelection(index) {
      const idx = this.selectedDocumentIndices.indexOf(index);
      if (idx === -1) this.selectedDocumentIndices.push(index);
      else this.selectedDocumentIndices.splice(idx, 1);
    },
    toggleSelectAllDocuments(ev) {
      const checked = ev && ev.target && ev.target.checked;
      this.selectedDocumentIndices = checked ? this.documentRows.map((_, i) => i) : [];
    },
    toggleSelectAllFilteredDocuments(ev) {
      const checked = ev && ev.target && ev.target.checked;
      const filteredIndices = this.filteredDocumentRows.map((item) => item.index);
      if (checked) {
        const set = new Set([...this.selectedDocumentIndices, ...filteredIndices]);
        this.selectedDocumentIndices = [...set];
      } else {
        const set = new Set(filteredIndices);
        this.selectedDocumentIndices = this.selectedDocumentIndices.filter((i) => !set.has(i));
      }
    },

    getStatusLabel(status) {
      if (!status) return "-";
      const translated = this.$t(status);
      if (translated !== status) return translated;
      return this.statusFallbacks[status] || status;
    },
    getDossierPipelineStatus(dossier) {
      const sp = dossier?.sous_pipelines?.[0];
      const pipeline = sp?.pipeline || dossier?.pipelines?.[0];
      if (pipeline?.name) return pipeline.name;
      return this.getStatusLabel(dossier?.status) || "-";
    },
    getDossierSousStatus(dossier) {
      const sp = dossier?.sous_pipelines?.[0];
      return sp?.name || "-";
    },

    getStatusChipClass(status) {
      if (!status) return "chip-default";
      const map = {
        DOSSIER_STATUS_EN_COURS: "chip-en-cours",
        DOSSIER_STATUS_NON_SIGNE: "chip-non-signe",
        DOSSIER_STATUS_SIGNE: "chip-signe",
        DOSSIER_STATUS_POSE_EN_COURS: "chip-pose-en-cours",
        DOSSIER_STATUS_POSE_TERMINE: "chip-pose-termine",
        DOSSIER_STATUS_CONTROLE_A_PLANIFIER: "chip-controle",
        DOSSIER_STATUS_TRAITEMENT_ADMIN: "chip-traitement-admin",
        DOSSIER_STATUS_A_DEPOSER: "chip-a-deposer",
        DOSSIER_STATUS_DEPOSE: "chip-depose",
        DOSSIER_STATUS_PAYE: "chip-paye",
      };
      return map[status] || "chip-default";
    },

    isDossierSelected(dossier) {
      return this.selectedDossiers.some((d) => d.id === dossier.id);
    },

    toggleDossierSelection(dossier) {
      const idx = this.selectedDossiers.findIndex((d) => d.id === dossier.id);
      if (idx >= 0) {
        this.selectedDossiers.splice(idx, 1);
      } else {
        this.selectedDossiers.push(dossier);
      }
    },

    toggleSelectAllDossiers() {
      if (this.isAllDossiersSelected) {
        this.selectedDossiers = [];
      } else {
        this.selectedDossiers = [...(this.getAlldossiers || [])];
      }
    },

    updateSearch(s) {
      this.page = 1;
      this.search = s;
    },

    buildFilterPayload(extra = {}) {
      return {
        page: this.page,
        per_page: this.perPage,
        search: this.search,
        client_id: this.filterClient ? this.filterClient.id : null,
        entreprise_id: this.isSuperAdmin && this.filterEntreprise ? this.filterEntreprise.id : null,
        status: this.filterStatus || null,
        date_from: this.filterDateFrom || null,
        date_to: this.filterDateTo || null,
        ...extra,
      };
    },

    async applyFilters(payloadFromBar = null) {
      if (payloadFromBar && typeof payloadFromBar === "object") {
        if (payloadFromBar.search !== undefined) this.search = payloadFromBar.search;
        if (payloadFromBar.page !== undefined) this.page = payloadFromBar.page;
        await this.alldossier(payloadFromBar);
      } else {
        await this.alldossier(this.buildFilterPayload());
      }
    },

    applyFiltersAndClose() {
      this.$refs.entrepriseModal.hide();
      this.page = 1;
      this.applyFilters();
    },

    clearFiltersAndClose() {
      this.filterClient = null;
      this.filterEntreprise = null;
      this.filterStatus = null;
      this.filterDateFrom = "";
      this.filterDateTo = "";
      this.$refs.entrepriseModal.hide();
      this.page = 1;
      this.applyFilters();
    },

    selectFilterClient(item) {
      this.filterClient = item;
    },
    selectFilterEntreprise(item) {
      this.filterEntreprise = item;
      this.filterClient = null;
      this.all_clients({
        page: 1,
        per_page: 1000,
        entreprise_id: item ? item.id : null,
      });
    },
    clearFilterClient() {
      this.filterClient = null;
      this.applyFilters();
    },
    clearFilterEntreprise() {
      this.filterEntreprise = null;
      this.applyFilters();
    },
    clearFilterStatus() {
      this.filterStatus = null;
      this.applyFilters();
    },
    clearFilterDate() {
      this.filterDateFrom = "";
      this.filterDateTo = "";
      this.applyFilters();
    },

    validateState(name) {
      const { $dirty, $error } = this.v$.dossierToConfig[name];
      return $dirty ? !$error : null;
    },

    openUpload(type) {
      if (type.name == "Devis") {
        this.devis({
          page: 1,
          per_page: 1000,
          client: this.dossierDetail.client_id,
        });
      } else {
        this.factures({
          page: 1,
          per_page: 1000,
          client: this.dossierDetail.client_id,
        });
      }

      this.document.type = type;
      this.$root.$emit("bv::show::modal", "uploadDocument");
    },

    downloadFile(doc, key) {
      this.$set(this.fileLoading, key, true);

      this.download_file(doc.file.id)
        .then((file) => {
          // Crée un lien de téléchargement temporaire
          const url = window.URL.createObjectURL(new Blob([file]));

          // Crée un élément d'ancrage <a> pour démarrer le téléchargement
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${doc.name}.pdf`); // Définit le nom du fichier à télécharger

          // Simule un clic sur le lien pour démarrer le téléchargement

          this.$set(this.fileLoading, key, false);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(() => {
          this.$set(this.fileLoading, key, false);
        });
    },

    selectentreprise(query) {
      if (query) {
        this.filtre_client = query;
      } else {
        this.filtre_client = {
          lib: null,
        };
      }
      this.setup(true);
    },

    async uploadDocument(tab) {
      var bodyFormData = new FormData();
      bodyFormData.append("ocr_file_type_id", this.document.type.id);
      bodyFormData.append("ocr_dossier_id", this.dossierDetail.id);

      if (tab == 0) {
        if (!this.document.doc) return;
        bodyFormData.append("batigo_file_id", this.document.doc.id);
      } else {
        bodyFormData.append("file", this.document.file);
      }
      const file = await this.upload_file(bodyFormData);
      this.hideModal("uploadDocument");
      this.getOcrFileType.forEach((type) => {
        if (type.id == file.ocr_file_type_id) type.file = file;
      });
      this.document = {
        type: null,
        file: null,
        doc: null,
      };
      this.dossierDetail = await this.one_dossier(this.dossierDetail.id);
    },

    async handleUpload(event, key) {
      this.$set(this.fileLoading, key, true);
      var bodyFormData = new FormData();
      bodyFormData.append("ocr_file_type_id", this.getOcrFileType[key].id);
      bodyFormData.append("ocr_dossier_id", this.dossierDetail.id);
      bodyFormData.append("file", event.target.files[0]);

      try {
        this.getOcrFileType[key].file = await this.upload_file(bodyFormData);

        this.dossierDetail = await this.one_dossier(this.dossierDetail.id);
        this.$set(this.fileLoading, key, false);
      } catch (err) {
        this.erreur = err;
        this.$set(this.fileLoading, key, false);

        this.$refs["ModelError"].show();
      }
    },

    async handleDeleteFile(key) {
      this.$set(this.fileLoading, key, true);

      this.$bvModal
        .msgBoxConfirm(`${this.$t("DELETE_ACCOUNT_MESSAGE")}`, {
          title: `${this.$t("CONFIRM")}`,
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          cancelVariant: "danger",
          okTitle: `${this.$t("YES")}`,
          cancelTitle: `${this.$t("NO")}`,
          footerClass: "p-2",
          hideHeaderClose: false,
        })
        .then((value) => {
          if (value) {
            this.deleteFile(key);
          }
        });

      this.$set(this.fileLoading, key, false);
    },

    async deleteFile(key) {
      await this.delete_file(this.getOcrFileType[key].file.id);
      this.getOcrFileType[key].file = null;
      this.dossierDetail = await this.one_dossier(this.dossierDetail.id);
    },

    async searchDossier() {
      await this.applyFilters();
    },
    hideModal(ref) {
      this.$refs[ref].hide();
    },
    handleUpdate(CAT) {
      this.dossierToConfig = {
        client: this.getAllclients.find((item) => item.id == CAT.client_id),
        ...CAT,
      };
      this.$refs["ModelConfigDossier"].show();
    },

    handleDelete(CAT) {
      this.dossierToDelete = { ...CAT };
      this.$root.$emit("bv::show::modal", "ModelDelete");
    },

    goToDetail(id) {
      this.$router.push({ name: "DossierDetail", params: { id } });
    },

    async handleDossier(CAT) {
      this.dossierDetail = { ...CAT };
      this.dossierResume = null;
      this.dossierResumeLoading = true;
      this.$root.$emit("bv::show::modal", "detailModal");
      try {
        const resume = await this.getDossierResume(CAT.id);
        this.dossierResume = resume;
        this.dossierDetail = resume?.dossier || { ...CAT };
      } catch (e) {
        console.warn("Dossier resume failed", e);
        this.dossierDetail = { ...CAT };
        this.OcrFileTypes({}).then(() => {
          this.getOcrFileType.forEach((type) => {
            this.fileLoading.push(false);
            type.file = null;
          });
          this.allfiles(CAT.id).then(() => this.fusionFileType());
        });
      } finally {
        this.dossierResumeLoading = false;
      }
    },

    fusionFileType() {
      this.getOcrFiles.forEach((file) => {
        this.getOcrFileType.forEach((type) => {
          if (type.id == file.ocr_file_type_id) {
            type.file = file;
          }
        });
      });
    },

    handleSend() {
      this.send_dossier(this.dossierDetail.id).then(() => {
        this.hideModal("detailModal");
        this.setup();
      });
    },

    resetModal() {
      this.erreurlist = {
        name: null,
        client_id: null,
      };
      this.errorU = null;
      this.dossierResume = null;
      this.setup();
      this.hideModal("ModelConfigDossier");
      this.hideModal("detailModal");
    },

    async EditDossier() {
      const isFormCorrect = await this.v$.dossierToConfig.$error;
      this.erreurlist = {
        name: null,
        client_id: null,
      };
      this.errorU = null;
      if (isFormCorrect) return;
      const data = {
        id: this.dossierToConfig.id,
        name: this.dossierToConfig.name,
        description: this.dossierToConfig.description,
      };

      await this.edit_dossier(data)
        .then(() => {
          this.hideModal("ModelConfigDossier");
          this.errorU = null;
        })
        .catch((err) => {
          this.errorU = err;
          // if (this.isObject(err)) {
          //   for (const [key, value] of Object.entries(err)) {
          //     if (this.erreurlist[key] && !this.erreurlist[key]) {
          //       this.erreurlist[key] = value;
          //     }
          //   }
          // } else {
          //   this.errorU = err;
          // }
        });
    },

    handleStore() {
      this.$root.$emit("bv::show::modal", "dossierModal");
    },
    async handleLockSelection() {
      const ids = this.selectedDossiers.map((d) => d.id).filter(Boolean);
      if (!ids.length) return;
      try {
        this.lockActionLoading = true;
        await this.lock_dossiers({ ids });
        if (this.dossierDetail && ids.includes(this.dossierDetail.id)) {
          this.dossierDetail = await this.one_dossier(this.dossierDetail.id);
        }
        this.$bvToast &&
          this.$bvToast.toast(this.$t("LOCK_SUCCESS") || "Dossiers verrouillés.", {
            variant: "success",
            autoHideDelay: 3000,
          });
        this.selectedDossiers = [];
      } catch (err) {
        this.$bvToast &&
          this.$bvToast.toast(
            err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur",
            { variant: "danger", autoHideDelay: 4000 }
          );
      } finally {
        this.lockActionLoading = false;
      }
    },
    async handleUnlockSelection() {
      const ids = this.selectedDossiers.map((d) => d.id).filter(Boolean);
      if (!ids.length) return;
      try {
        this.lockActionLoading = true;
        await this.unlock_dossiers({ ids });
        if (this.dossierDetail && ids.includes(this.dossierDetail.id)) {
          this.dossierDetail = await this.one_dossier(this.dossierDetail.id);
        }
        this.$bvToast &&
          this.$bvToast.toast(this.$t("UNLOCK_SUCCESS") || "Dossiers déverrouillés.", {
            variant: "success",
            autoHideDelay: 3000,
          });
        this.selectedDossiers = [];
      } catch (err) {
        this.$bvToast &&
          this.$bvToast.toast(
            err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur",
            { variant: "danger", autoHideDelay: 4000 }
          );
      } finally {
        this.lockActionLoading = false;
      }
    },
    async handleExport() {
      const ids = this.selectedDossiers.map((d) => d.id).filter(Boolean);
      if (!ids.length) return;
      try {
        this.$bvToast &&
          this.$bvToast.toast(this.$t("EXPORT") || "Export en cours...", { variant: "info", autoHideDelay: 2000 });
        const result = await this.export_dossier(ids);
        if (!result || !result.blob) return;
        let filename = ids.length === 1 ? `dossier_${ids[0]}_export.zip` : `dossiers_export.zip`;
        const disposition = result.headers && result.headers["content-disposition"];
        if (disposition) {
          const match =
            disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i) ||
            disposition.match(/filename=["']?([^"';]+)["']?/i);
          if (match && match[1]) filename = match[1].trim();
        }
        const url = window.URL.createObjectURL(result.blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.$bvToast &&
          this.$bvToast.toast(this.$t("EXPORT_SUCCESS") || "Export téléchargé.", { variant: "success", autoHideDelay: 3000 });
      } catch (err) {
        this.$bvToast &&
          this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", {
            variant: "danger",
            autoHideDelay: 5000,
          });
      }
    },
    resetImportModal() {
      this.importZipFile = null;
      this.importDossierLoading = false;
      this.importTemplateFile = null;
      this.importTemplateLoading = false;
    },
    async handleImportTemplate() {
      if (!this.importTemplateFile) return;
      try {
        this.importTemplateLoading = true;
        this.$bvToast &&
          this.$bvToast.toast(this.$t("IMPORT") || "Import en cours...", { variant: "info", autoHideDelay: 2000 });
        await this.import_dossier(this.importTemplateFile);
        this.$refs.importDossierModal.hide();
        this.resetImportModal();
        await this.setup(true);
        this.$bvToast &&
          this.$bvToast.toast(this.$t("IMPORT_SUCCESS") || "Import réussi.", { variant: "success", autoHideDelay: 3000 });
      } catch (err) {
        this.$bvToast &&
          this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", {
            variant: "danger",
            autoHideDelay: 5000,
          });
      } finally {
        this.importTemplateLoading = false;
      }
    },
    async handleExportTemplate() {
      try {
        this.exportTemplateLoading = true;
        this.$bvToast &&
          this.$bvToast.toast(this.$t("EXPORT") || "Export en cours...", { variant: "info", autoHideDelay: 2000 });
        const result = await this.export_dossier_template();
        if (!result || !result.blob) return;
        let filename = "dossiers_export_template.zip";
        const disposition = result.headers && result.headers["content-disposition"];
        if (disposition) {
          const match =
            disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i) ||
            disposition.match(/filename=["']?([^"';]+)["']?/i);
          if (match && match[1]) filename = match[1].trim();
        }
        const url = window.URL.createObjectURL(result.blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.$bvToast &&
          this.$bvToast.toast(this.$t("EXPORT_SUCCESS") || "Modèle téléchargé.", { variant: "success", autoHideDelay: 3000 });
      } catch (err) {
        this.$bvToast &&
          this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", {
            variant: "danger",
            autoHideDelay: 5000,
          });
      } finally {
        this.exportTemplateLoading = false;
      }
    },
    async handleImport() {
      if (!this.importZipFile) return;
      try {
        this.importDossierLoading = true;
        this.$bvToast &&
          this.$bvToast.toast(this.$t("IMPORT") || "Import en cours...", { variant: "info", autoHideDelay: 2000 });
        await this.import_dossier(this.importZipFile);
        this.$refs.importDossierModal.hide();
        this.resetImportModal();
        this.setup(true);
        this.$bvToast &&
          this.$bvToast.toast(this.$t("IMPORT_SUCCESS") || "Import réussi.", { variant: "success", autoHideDelay: 3000 });
      } catch (err) {
        this.$bvToast &&
          this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", {
            variant: "danger",
            autoHideDelay: 5000,
          });
      } finally {
        this.importDossierLoading = false;
      }
    },
    selectClient(item) {
      this.dossierToConfig.client = item;
    },

    pagination(paginate) {
      this.page = paginate;
      this.searchDossier();
    },

    setup(refresh = false) {
      if (refresh) this.page = 1;
      this.search = null;
      this.applyFilters();
    },
  },

  watch: {
    viewMode(val) {
      if (val === "list") {
        this.applyFilters();
      }
    },
  },

  mounted() {
    this.setup(true);
    if (this.isSuperAdmin) {
      this.all_entreprises({ page: 1, per_page: 1000 });
    }
    this.all_clients({ page: 1, per_page: 1000 });
  },

  computed: {
    ...mapGetters([
      "getAlldossiers",
      "getLoadingdossier",
      "getTotalRowDossier",
      "getPipelineLoading",
      "getTabs",
      "getOnlineUser",
      "getAllDelegataire",
      "getDelegataireLoading",
      "getAllclients",
      "getclientLoading",
      "getAllentreprises",
      "getentrepriseLoading",
      "getOcrFileType",
      "getOcrFiles",
      "getAlldevis",
      "getdevisLoading",
      "getFactureLoading",
      "getAllFacture",
    ]),
    isSuperAdmin() {
      return this.getOnlineUser && this.getOnlineUser.role === "user.super-admin";
    },
    activeProcessusId() {
      const list = this.getAlldossiers || [];
      for (const d of list) {
        const pid = d.pipelines?.[0]?.processus_id ??
          d.pipeline_tasks?.[0]?.sous_pipeline?.pipeline?.processus_id;
        if (pid != null) {
          const num = parseInt(pid, 10);
          return isNaN(num) ? null : num;
        }
      }
      return null;
    },
    currentFiltre() {
      return {
        client_id: this.filterClient ? this.filterClient.id : null,
        entreprise_id: this.isSuperAdmin && this.filterEntreprise ? this.filterEntreprise.id : null,
        status: this.filterStatus || null,
        date_from: this.filterDateFrom || null,
        date_to: this.filterDateTo || null,
      };
    },
    filterClientFiltre() {
      if (!this.isSuperAdmin || !this.filterEntreprise) return {};
      return { entreprise_id: this.filterEntreprise.id };
    },
    filterStatusOptions() {
      return Object.entries(this.statusFallbacks).map(([value, text]) => ({ value, text }));
    },
    computedDevis() {
      return this.getAlldevis.map((item) => item.devis);
    },
    computedFacture() {
      return this.getAllFacture.map((item) => item.facture);
    },
    isAllDossiersSelected() {
      const list = this.getAlldossiers || [];
      return list.length > 0 && this.selectedDossiers.length === list.length;
    },
    isSomeDossiersSelected() {
      const n = this.selectedDossiers.length;
      const total = (this.getAlldossiers || []).length;
      return n > 0 && n < total;
    },
    resumeDocumentRows() {
      const raw = this.dossierResume?.documents;
      let docs = [];
      if (Array.isArray(raw)) docs = raw;
      else if (raw && typeof raw === "object") docs = Object.values(raw).flat().filter(Boolean);
      return docs.map((d) => {
        const t = (d && d.type) || (d && d.doc_type) || "";
        const typeLabel = t === "document_dossier" ? (this.$t("DOCUMENT") || "Document") : (t === "devis" ? (this.$t("DEVIS") || "Devis") : (t === "cee" ? "CEE" : t || "-"));
        return {
          typeLabel,
          numero: (d && (d.numero ?? d.numerodevis ?? d.numerofacture)) ?? "-",
          created_at: d && d.created_at,
        };
      });
    },
    resumeDocumentCountByType() {
      const rows = this.resumeDocumentRows || [];
      const byType = {};
      rows.forEach((doc) => {
        const label = doc.typeLabel || "-";
        byType[label] = (byType[label] || 0) + 1;
      });
      return Object.entries(byType).map(([typeLabel, count]) => ({ typeLabel, count }));
    },
    resumeTotalDocuments() {
      const resume = this.dossierResume;
      if (!resume) return 0;
      
      // Compter les AH
      const ahCount = Array.isArray(resume.ah) ? resume.ah.length : 0;
      
      // Compter les CEE
      const ceeCount = Array.isArray(resume.cee) ? resume.cee.length : 0;
      
      // Compter les Devis (numerodevis) et Factures (numerofacture)
      let devisCount = 0;
      let factureCount = 0;
      const devisList = Array.isArray(resume.devis) ? resume.devis : [];
      devisList.forEach((d) => {
        if (d.numerodevis) devisCount++;
        if (d.numerofacture) factureCount++;
      });
      
      return ahCount + ceeCount + devisCount + factureCount;
    },
    documentRows() {
      const types = this.getOcrFileType || [];
      return types.map((doc) => {
        const file = doc.file || {};
        return {
          typeId: doc.id,
          typeLabel: doc.name || "-",
          numero: file.numero ?? file.numero_document ?? file.numerodevis ?? file.numerofacture ?? null,
          nom: file.name ?? file.nom ?? doc.name ?? null,
          date: file.created_at ?? file.date ?? null,
          file: doc.file,
          raw: doc,
        };
      });
    },
    documentFilterTypeOptions() {
      return [
        { value: null, text: this.$t("ALL") || "Tous" },
        { value: "Devis", text: this.$t("DEVIS") || "Devis" },
        { value: "Facture", text: this.$t("FACTURE") || "Facture" },
        { value: "CEE", text: "CEE" },
        { value: "AH", text: "AH" },
      ];
    },
    filteredDocumentRows() {
      let list = this.documentRows.map((doc, index) => ({ doc, index }));
      const search = (this.documentSearch || "").trim().toLowerCase();
      if (search) {
        list = list.filter(({ doc }) => {
          const typeLabel = (doc.typeLabel || "").toLowerCase();
          const numero = String(doc.numero || "").toLowerCase();
          const dateStr = this.formatDocumentDate(doc.date).toLowerCase();
          return typeLabel.includes(search) || numero.includes(search) || dateStr.includes(search);
        });
      }
      if (this.documentFilterType !== null && this.documentFilterType !== "") {
        list = list.filter(({ doc }) => (doc.typeLabel || "") === this.documentFilterType);
      }
      return list;
    },
  },
};
</script>

<style lang="scss" scoped>
.status-chip {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.chip-default {
  background: #e9ecef;
  color: #495057;
}
.chip-en-cours {
  background: #cfe2ff;
  color: #084298;
}
.chip-non-signe {
  background: #e2e3e5;
  color: #41464b;
}
.chip-signe {
  background: #d1e7dd;
  color: #0f5132;
}
.chip-pose-en-cours {
  background: #cff4fc;
  color: #055160;
}
.chip-pose-termine {
  background: #d3f9d8;
  color: #2b8a3e;
}
.chip-controle {
  background: #fff3cd;
  color: #664d03;
}
.chip-traitement-admin {
  background: #e2d9f3;
  color: #432874;
}
.chip-a-deposer {
  background: #ffe5d0;
  color: #9c3d0e;
}
.chip-depose {
  background: #c8d6fa;
  color: #1d3a8a;
}
.chip-paye {
  background: #b2f2bb;
  color: #0d6832;
}

/* Vue Grille - Styles */
.gestion-grid-view {
  margin-top: 1.25rem;
  background: transparent;
  overflow: hidden;
}

.grid-empty-state {
  text-align: center;
  padding: 4rem 2rem;
  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 50%, #e2e8f0 100%);
  border-radius: 16px;
  margin: 1rem;
}

.grid-empty-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 1.5rem;
  background: linear-gradient(135deg, #465081 0%, #5a6ba3 100%);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.875rem;
  box-shadow: 0 8px 24px rgba(70, 80, 129, 0.3);
}

.grid-empty-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.grid-empty-text {
  color: #64748b;
  margin-bottom: 1.5rem;
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
  font-size: 0.95rem;
}

.grid-pipeline-wrapper {
  padding: 0;
  background: transparent;
}

.dossier-resume-content {
  padding: 0.5rem 0;
  max-height: 60vh;
  overflow-y: auto;
}
.resume-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
}
.resume-card {
  background: #f8f9fa;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e9ecef;
}
.resume-card-header {
  background: linear-gradient(135deg, #465081 0%, #5a6ba3 100%);
  color: #fff;
  padding: 0.75rem 1rem;
  font-weight: 600;
  font-size: 0.95rem;
}
.resume-card-body {
  padding: 1rem;
  font-size: 0.9rem;
}
.resume-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 0.5rem;
}
.resume-row {
  padding: 0.35rem 0;
}
.resume-row .label {
  font-weight: 500;
  color: #495057;
  margin-right: 0.5rem;
}
.resume-stats .resume-card-body {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 1rem;
  background: #fff;
  border-radius: 8px;
  min-width: 80px;
}
.stat-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #465081;
}
.stat-label {
  font-size: 0.75rem;
  color: #6c757d;
}
.resume-stats-docs {
  grid-column: 1 / -1;
}
.resume-stats-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: stretch;
}

.input-group .icon-balance {
  top: 8px;
}

.prodimg {
  padding: 8px;
  background: #465081;
  max-width: 64px;
  max-height: 64px;
}
.option {
  display: flex;
  align-items: center;
  .option__image {
    background-color: #465081;
    padding: 4px;
    max-height: 42px;
    max-width: 42px;
  }
}
.view-toggle-group {
  display: inline-flex;
  background: #f1f5f9;
  border-radius: 10px;
  padding: 4px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
}

.view-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748b;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
}

.view-toggle-btn:hover {
  color: #465081;
  background: rgba(70, 80, 129, 0.08);
}

.view-toggle-btn.active {
  background: linear-gradient(135deg, #465081 0%, #5a6ba3 100%);
  color: #fff;
  box-shadow: 0 2px 8px rgba(70, 80, 129, 0.35);
}

.gestion-page-header {
  margin-bottom: 0.5rem;
}

.header-card-block {
  display: flex;
  align-items: stretch;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.header-card-title {
  display: flex;
  align-items: center;
  padding: 14px 24px;
  min-height: 48px;
}

.header-card-h1 {
  font-size: 1.5rem;
  font-weight: 700;
 
  color: #374151;
  margin: 0;
}

.header-card-btn {
  background-color: #303f9f !important;
  border-color: #303f9f !important;
  color: #fff !important;
  border-radius: 0 10px 10px 0 !important;
  padding: 10px 20px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-card-btn:hover {
  background-color: #283593 !important;
  border-color: #283593 !important;
  color: #fff !important;
}

.inner-container .content {
  margin: 10px 15px;
  background-color: #fff;
  box-shadow: 1px 1px 24px #00000019;
  border-radius: 5px;
  padding: 14px;
  min-height: 88vh;
}

.content {
  & p {
    font-size: 12px;
    font-weight: 500;
    padding: 3px 0;
    margin: 0;
  }
}

.w-100 {
  background-color: #f8f8f8;
  padding: 4px;
  overflow-x: auto;
}

body {
  background: #fafdff;
}

.actionModel {
  position: relative;
  padding: 15px 0 0;
  flex-flow: column;
  align-items: center;
  .messageError {
    color: #e4261b;
    font-size: 16px;
    background-color: #fff;
    border-color: #fff;
  }
  & .block-spinner {
    display: flex;
    justify-content: center;
  }

  & .spinner-border {
    width: 1.5rem;
    height: 1.5rem;
  }
}

.detailClient {
  background-color: #fff;
  box-shadow: 1px 1px 24px #00000019;

  .clientTop {
    padding: 16px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border-bottom: 1px solid #707070;

    & .prodimg {
      max-width: 185px;
      max-height: 231px;
    }
  }

  & h4 {
    color: #28367a;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }

  & p {
    color: #515151;
    font-size: 16px;
    font-weight: 500;
  }
}
.filtre {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  .table-count,
  .productTrie {
    margin-right: 15px;
  }

  .productTrie {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    overflow: hidden;
    padding: 4px 8px;
    border-radius: 32px;
    background-color: #34c38f;
    color: #fff;

    .icons {
      cursor: pointer;
      width: 18px;
      height: 18px;
      margin-left: 4px;
    }
  }
}

.image-conteneur {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .block {
    cursor: pointer;
    width: 25%;
    margin-bottom: 16px;
    padding: 15px;
    &:hover {
      background-color: rgba($color: #000, $alpha: 0.1);
    }

    .image-content {
      img {
        width: 100%;
      }
    }

    p {
      margin: 0;
      text-align: center;
      color: #303030;
    }
  }
}

// modal detail
.modal-test {
  width: 95%;
  margin: auto;
}

.cours {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  p {
    margin: 0;
    color: #fff;
    background-color: #d0cccc;
    width: fit-content;
    padding: 4px;
    height: 24px;
    font-size: 13px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  button {
    font-size: 14px;
  }
}

.divborder {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  overflow: hidden;
  color: #28367a;
  width: 100%;
  p {
    margin: 0px 10px;
  }
}
.divborder::after,
.divborder::before {
  content: "";
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
  height: 1px;
  background-color: #d8d8d8;
}

.left {
  ul {
    list-style: none;
  }
  h2 {
    color: #28367a;
    font-weight: 700;
    margin-bottom: 0px;
  }
  .title {
    color: #28367a;
    font-weight: 700;
  }
}

.icon-verrouillage {
  margin-right: 6px;
  color: #e4261b;
  font-size: 1rem;
  vertical-align: middle;
}
.icon-deverrouillage {
  margin-right: 6px;
  color: #28a745;
  font-size: 1rem;
  vertical-align: middle;
}
</style>
